import { render, staticRenderFns } from "./redEnvelopes.vue?vue&type=template&id=1a24b54e&scoped=true&"
import script from "./redEnvelopes.vue?vue&type=script&lang=js&"
export * from "./redEnvelopes.vue?vue&type=script&lang=js&"
import style0 from "./redEnvelopes.vue?vue&type=style&index=0&id=1a24b54e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a24b54e",
  null
  
)

export default component.exports